import { render, staticRenderFns } from "./KForm.vue?vue&type=template&id=0c28bf50&"
import script from "./KForm.vue?vue&type=script&lang=ts&"
export * from "./KForm.vue?vue&type=script&lang=ts&"
import style0 from "./KForm.vue?vue&type=style&index=0&id=0c28bf50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports